import { Reducer, createSlice } from "@reduxjs/toolkit";
import { AppDispatch } from "../state";
import { SERVER_URL } from "../../utils/server";
import { Callback } from "../../index.d";
import { User } from "./authSlice";
import { toggleSessionExpired } from "../utils/uiSlice";
import { pageSizeReq } from "../../utils/constants";

export declare interface BossState {
  [index: string]: any;
}
const initialState: BossState = {};

export const bossSlice = createSlice({
  initialState,
  name: "boss",
  reducers: {
    createBoss: (state, action) => {
      state[action.payload.id] = action.payload;
      return state;
    },
    listBoss: (state, action) => {
      for (const obj of action.payload) {
        state[obj.id] = obj;
      }
      return state;
    },
    removeBoss: (state, action) => {
      delete state[action.payload];
      return state;
    },
    updateBoss: (state, action) => {
      state[action.payload.id] = {
        ...state[action.payload.id],
        ...action.payload,
      };
      return state;
    },
  },
});

export const { createBoss, listBoss, removeBoss, updateBoss } =
  bossSlice.actions;

export const createAsyncBoss =
  (data: User, callback: Callback, onError: Callback) =>
  async (dispatch: AppDispatch, getState: any) => {
    try {
      const user = getState().auth.user;
      const result = await fetch(`${SERVER_URL}utilisateur`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.token}`,
        },
      });

      if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
        return;
      }

      if (result.status === 201) {
        dispatch(listAsyncBoss())
        callback?.();
      } else {
        onError?.();
      }
    } catch (error) {
      console.log("sign in error", error);
      onError?.();
    }
  };

export const listAsyncBoss =
  () => async (dispatch: AppDispatch, getState: any) => {
    try {
      const user = getState().auth.user;

      const result = await fetch(`${SERVER_URL}boss/admin-all?size=${pageSizeReq}&page=1`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${user?.token}`,
        },
      });

      if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
        return;
      }

      const res = await result.json();

      if (res.data?.length) {
        dispatch(listBoss(res.data));
      }
    } catch (error) {
      console.log("list boss error", error);
    }
  };

  export const getAsyncBoss =
  (id:string, callback: Callback) => async (dispatch: AppDispatch, getState: any) => {
    try {
      const user = getState().auth.user;

      const result = await fetch(
        `${SERVER_URL}boss/admin-all/${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.token}`,
          },
        }
      );

      if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
        return;
      }

      const res = await result.json();
      callback(res);
     
    } catch (error) {
      console.log("get boss error", error);
      // onError?.();
    }
  };

  export const exportAsyncBoss =
  (callback?: Callback) => async (dispatch: AppDispatch, getState: any) => {
    try {
      const user = getState().auth.user;

      const result = await fetch(
        `${SERVER_URL}boss/admin-all/export`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.token}`,
          },
        }
      );

      if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
        return;
      }

      const resBlob = await result.blob();

      callback?.(resBlob);
     
    } catch (error) {
      console.log("export boss error", error);
      // onError?.();
    }
  };

export default bossSlice.reducer as Reducer<BossState>;
